module.exports = __webpack_public_path__ + "img/sal-3.bd267a9d.jpeg";